import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { MUITheme } from 'shared/integrations/mui'

import './shared/polyfills'
import store from './redux/store'
// eslint-disable-next-line perfectionist/sort-imports
import { App, init } from './components/app'

init()

const root = ReactDOM.createRoot(document.getElementById('root')!)

root.render(
	<Provider store={store}>
		<MUITheme>
			<App />
		</MUITheme>
	</Provider>
)
